<template>
  <section id="conventionalTrackingRequestList" class="page-content">
    <header id="section-header">
      <p class="title has-text-grey">Conventional Tracking Request</p>
      <p class="subtitle has-text-grey">Search Tracking.</p>
    </header>
    <main id="section-body">
      <div class="filters">
        <div class="filter">
          <label>Search</label>
          <div class="control">
            <input class="input" type="text" placeholder="Search for tracking requests..." v-model="filters.search"
              @keyup="debouncedGetAnswer" name="search" id="search">
          </div>
        </div>
        <div class="filter">
          <label>Tracking Request Status</label>
          <div class="control">
            <button-group-filter @change="debouncedGetAnswer" :collection="STATUS_FILTER" :target="filters.status" />
          </div>
        </div>
        <div class="filter">
          <label class="ml-1">Management</label>
          <div class="control">
            <Button
              label="Configure Columns"
              class="button filter-reset is-primary is-small"
              icon="fa fa-lg fa-columns"
              iconPos="left"
              @click="showCustomColumns = true"
            />
            <Button
              label="Export List"
              class="button filter-reset is-primary is-small"
              icon="pi pi-file-excel"
              iconPos="left"
              @click="exportList"
            />
            <Button
              label="Filter"
              class="button filter-reset is-primary is-small"
              icon="pi pi-filter-fill" iconPos="left"
              @click="showCustomFilters = true"
            />
            <Button
              label="Reset Filters"
              class="button filter-reset is-primary is-small"
              icon="pi pi-eraser"
              iconPos="left"
              @click="clearFilters"
            />
          </div>
        </div>
      </div>
      <div v-if="tags.length > 0" class="filter-section">
        <Divider class="filter-list" align="center">
          <div class="inline-flex align-items-center">
            <i class="pi pi-filter-fill mr-2"></i>
            <b>Current filter list</b>
          </div>
        </Divider>
        <div class="grid">
          <div v-for="(tag, index) in tags" :key="index" class="tags-container col-12 md:col-6">
            <div class="tags-special">
              <Chip class="tag-special black">{{ tag.name }}</Chip>
              <Chip class="tag-special grey">{{ tag.type }}</Chip>
              <Chip class="tag-special green">{{ tag.value }}</Chip>
              <span class="close-icon" @click="removeFilter(tag, index)">&times;</span>
            </div>
          </div>
        </div>
      </div>
      <spinner v-show="loadingList"></spinner>
      <div v-show="!loadingList">
        <data-table
          url="shipment-conventional"
          :expand="['shipments_count']"
          editUrl="tracking-requests"
          :titleStyle="'text-transform:uppercase;font-family: MuseoSans-700; color: #138366'"
          :objects="objects"
          :schema="schema"
          :ordering="selectedHeaders"
          @order="filters.ordering=$event;debouncedGetAnswer()"
          :totalItems="count"
          :title="'Tracking Requests'"
          :alias="{'vessel_imo': 'Vessel Imo', 'vessel_status': 'Shipment Status', 'status': 'Tracking Status'}"
          :mappers="{ 'vessel_status': VESSEL_STATUS, 'milestone': MILESTONE}"
          :fields="columns"
          @expand="loadTrackingRequest($event)"
        >
          <div slot-scope="actions" v-if="hasPermission('canWrite')">
            <div slot="trigger" class="button is-success is-small" @click="objectDocs=actions.object;showDocs=true;">
              <span>Docs</span>
            </div>
            <modal-confirm
            :disabled="!actions.object.archivable"
            @confirm="retryTracking(actions.object)">
            <div slot="title">Confirm Retry</div>
            <span slot="body">Are you sure you want to <strong>retry</strong> this tracking?</span>
            <div slot="footer">
              <button class="button" @click="showModal = false; $emit('close')">
                No, I'm not
              </button>
              <button class="button is-primary" @click="showModal = false; $emit('confirm')">
                Yes, I'm sure
              </button>
            </div>
            <div slot="trigger" class="button is-success is-small" v-if="['invalid'].indexOf(actions.object.status) >= 0">Retry</div>
            </modal-confirm>
            <modal-confirm
            :disabled="!actions.object.archivable"
            @confirm="changeStatus(actions.object, 'archived')">
            <div slot="title">Confirm archive</div>
            <span slot="body">Are you sure you want to <strong>archive</strong> this tracking?</span>
            <div slot="footer">
              <button class="button" @click="showModal = false; $emit('close')">
                No, I'm not
              </button>
              <button class="button is-primary" @click="showModal = false; $emit('confirm')">
                Yes, I'm sure
              </button>
            </div>
            <div slot="trigger" class="button is-success is-small" v-if="['invalid', 'cancelled', 'archived', 'pending_archiving', 'pending_cancelling'].indexOf(actions.object.status) < 0">Archive</div>
          </modal-confirm>

          <modal-confirm
          :disabled="!actions.object.cancellable"
          @confirm="changeStatus(actions.object, 'cancelled')">
          <div slot="title">Confirm cancel</div>
          <span slot="body">Are you sure you want to <strong>cancel</strong> this tracking?</span>
          <div slot="footer">
            <button class="button" @click="showModal = false; $emit('close')">
              No, I'm not
            </button>
            <button class="button is-primary" @click="showModal = false; $emit('confirm')">
              Yes, I'm sure
            </button>
          </div>
          <div slot="trigger" class="button is-success is-small" v-if="['invalid', 'cancelled', 'archived', 'pending_archiving', 'pending_cancelling'].indexOf(actions.object.status) < 0">Cancel</div>
            </modal-confirm>
          </div>
          <template slot="status" slot-scope="scope">
            <span class="status-tag" :class="scope.obj.value">{{scope.obj.formated}}</span>
          </template>
        </data-table>
        <pagination
        :currentPage.sync="page"
        :totalItems="count"
        :itemsPerPage="pageSize"
        />
      </div>
      <modal v-if="showCustomColumns" :columns="tableHeaders" @close="showCustomColumns = false" width="90%">
        <div slot="header" style="font-size:18px;font-weight:600;margin-bottom:-15px;" class="title">Pick the columns you
          want to show
        </div>
        <custom-columns slot="body" :columns="tableHeaders" :previousSelected="selectedHeaders"
        @close="showCustomColumns = false; updateHeaders($event)" />
      </modal>
      <docs-modal v-if="showDocs" @close="showDocs=false" width="60em" :object="objectDocs" />
      <modal v-if="showCustomFilters" :customFilters="customFilters" @close="showCustomFilters = false" width="45%">
        <div slot="header" style="font-size:18px;font-weight:600;margin-bottom:-15px;" class="title">Filters</div>
        <custom-filters slot="body" :customFilters="customFilters" :previousFilters="filters" :previousTags="tags"
        @apply="updateFilters($event)" />
      </modal>
    </main>
  </section>

</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import conventionalShipment from '@/models/conventional/shipment'
import conventionalTrackingRequest from '@/models/conventional/trackingRequest'
import DataTable from '../../components/DataTable.vue'
import DateRangeFilter from '@/components/DateRangeFilter'
import ButtonGroupFilter from '@/components/ButtonGroupFilter'
import HealthFilter from '@/components/HealthFilter'
import Spinner from '@/components/Spinner'
import CustomFilters from '@/components/CustomFilters'
import CustomColumns from '@/components/CustomColumns'
import PaginatedFilteredListMixin from '@/pages/mixins/PaginatedFilteredListMixin'
import Pagination from '@/components/Pagination'
import Modal from '@/components/Modal'
import ModalConfirm from '@/components/ModalConfirm'
import DocsModal from '@/components/DocsModal'
import { filterConventionalShipmentList, mapFilterTypes } from '@/models/filters/FilterTypes'
import _ from 'lodash'

export default {
  name: 'conventional-tracking-request-list',
  components: { DataTable, ModalConfirm, Modal, DateRangeFilter, Pagination, ButtonGroupFilter, HealthFilter, CustomFilters, CustomColumns, Spinner, DocsModal },
  mixins: [PaginatedFilteredListMixin],
  created () {
    this.debouncedGetAnswer = _.debounce(this.applyFilters, 500)
  },
  mounted () {
    this.$emit('loading')
    this.loadHeaders()
    const promises = [
      this.getUserInfo().then(response => {
        this.user = response
        this.companyDefaultForm = this.user.userprofile.company.attachment_schema_form
      }),
      this.getPage(this.page)
    ]
    Promise.all(promises).then(data => { this.$emit('loaded') })
    if (this.$route.query.health.length > 0) {
      this.filters.health = this.$route.query.health[0]
    }
    this.customFilters = filterConventionalShipmentList()
  },
  data () {
    return {
      selectedHeaders: [],
      showCustomColumns: false,
      fixedHeaders: ['id'],
      tableHeaders: [
        'id',
        'vessel_imo',
        'status',
        'created_at',
        'port_of_loading',
        'port_of_discharge',
        'vessel_status'
      ],
      detailTableheaders: ['id', 'milestone'],
      schema: conventionalTrackingRequest.schema(),
      STATUS: conventionalTrackingRequest.STATUS,
      STATUS_FILTER: conventionalTrackingRequest.STATUS_FILTER,
      SHIPMENTS_HEALTH: conventionalTrackingRequest.SHIPMENTS_HEALTH,
      VESSEL_STATUS: conventionalShipment.VESSEL_STATUS,
      MILESTONE: conventionalShipment.MILESTONE,
      objects: [],
      filters: this.initializeFilters(),
      conventionalTrackingRequest: {},
      showRequestModal: false,
      customFilters: [],
      showCustomFilters: false,
      showDocs: false,
      filterTypes: [],
      page: 1,
      tags: [],
      objectDocs: {}
    }
  },

  computed: {
    ...mapState({
      count: state => state.conventionalTrackingRequest.count,
      pageSize: state => state.pageSize
    }),
    ...mapGetters({ hasPermission: 'hasPermission' }),
    columns () {
      var selectedHeaders = this.selectedHeaders.filter((x) => this.tableHeaders.indexOf(x) >= 0)
      let columns = this.fixedHeaders.concat(selectedHeaders)
      if (selectedHeaders.length === 0) {
        columns = columns.concat(this.tableHeaders)
      }
      return [...new Set(columns)]
    }
  },

  watch: {
    'page' () { this.getPage(this.page) },
    userInfo () {
      this.loadHeaders()
    }
  },

  methods: {
    ...mapActions({
      getUserInfo: 'user/readUserConfig',
      saveUserInfo: 'user/saveUserConfig',
      getObjects: 'conventionalTrackingRequest/list',
      postTrackingRetry: 'conventionalTrackingRequest/retry',
      transition: 'conventionalTrackingRequest/transition',
      exportConventionalTrackingRequest: 'conventionalTrackingRequest/export'
    }),

    exportList () {
      document.body.style.cursor = 'wait'
      let params = Object.assign({},
        this.filters
      )
      params.page = undefined
      this.generating = true
      this.exportConventionalTrackingRequest(params).then(response => {
        document.body.style.cursor = 'default'
      }).catch(error => {
        document.body.style.cursor = 'default'
        throw error
      })
    },

    loadHeaders () {
      this.selectedHeaders = this.tableHeaders.slice()
      if (this.userInfo && this.userInfo.userprofile && this.userInfo.userprofile.trackings_fields) {
        this.selectedHeaders = this.userInfo.userprofile.trackings_fields
      }
    },

    updateHeaders (headers) {
      this.selectedHeaders = headers
      var user = this.userInfo.userprofile
      user.trackings_fields = this.selectedHeaders
      this.saveUserInfo({id: this.userInfo.id, userprofile: user})
    },

    loadTrackingRequest (object) {
      this.getTrackingRequest(object.id).then((response) => {
        this.conventionalTrackingRequest = response
        this.showRequestModal = true
      })
    },

    retryTracking (object) {
      this.postTrackingRetry(object.id).then(response => {
        this.$notify({
          group: 'global',
          title: 'Success',
          text: 'The Tracking status has been successfully changed',
          duration: 4000,
          type: 'success'
        })
        this.getPage(this.page)
      })
    },
    changeStatus (object, status) {
      var data = { id: object.id, newStatus: status }
      this.transition(data).then(response => { object.status = response.status })
    },

    /**
   ** Updates the tags based on the current filters. Generates tags representing the applied filters and their values, and adds them to the tags array.
    * @returns {Array} - An array of objects representing the tags.
    */
    updateTags () {
      const tags = []

      for (const filterKey in this.filters) {
        let filterValue = this.filters[filterKey]
        const filterElement = this.customFilters.find(filter => filterKey.includes(filter.code))
        if (!filterElement) continue

        const key = filterElement.code

        for (const filterType of filterElement.types) {
          const filterTypeData = this.filterTypes[filterType]
          if (!filterTypeData) continue

          const params = filterTypeData.params
          const codeParams = params.length > 0 ? params.map(param => key + '_' + param) : [key]

          if (params.length > 0) {
            for (const param of filterTypeData.params) {
              if (!filterKey.includes(param)) continue

              if (filterValue) {
                const existingTag = tags.find(tag => tag.name === filterElement.name && tag.type === filterTypeData.name)
                if (existingTag) existingTag.value += ` To ${filterValue}`
                else {
                  if (param === 'isnull') filterValue = filterValue ? 'No' : 'Yes'
                  tags.push({
                    name: filterElement.name,
                    type: filterTypeData.name,
                    code: codeParams,
                    value: filterValue
                  })
                }
              }
            }
          } else {
            const paramName = `${filterKey}`
            let value = filterValue

            if ((Array.isArray(value) && value.length > 0) || (!Array.isArray(value) && value)) {
              if (paramName === 'carrier' && Array.isArray(value) && value.length > 0) {
                value.forEach(id => {
                  const carrier = this.carriers.find(carrier => carrier.id === parseInt(id))
                  tags.push({
                    name: filterElement.name,
                    type: filterTypeData.name,
                    code: codeParams,
                    value: carrier.official_name,
                    id: carrier.id
                  })
                })
              } else if (paramName === 'shipment_status' && Array.isArray(value) && value.length > 0) {
                value.forEach(id => {
                  const milestone = this.milestones.find(milestone => milestone.id === parseInt(id))
                  tags.push({
                    name: filterElement.name,
                    type: filterTypeData.name,
                    code: codeParams,
                    value: milestone.description,
                    id: milestone.id
                  })
                })
              } else {
                tags.push({
                  name: filterElement.name,
                  type: filterTypeData.name,
                  code: codeParams,
                  value: value
                })
              }
            }
          }
        }
      }

      return tags
    },

    /**
    ** Updates the filters based on the provided object. If the object has no filters, it resets the filters and clears the tags. Otherwise, it merges the filters with the existing ones, applies the filters, and updates the tags.
    * @param {Object} obj - The object containing filters and tags to update.
    */
    updateFilters (obj) {
      if (Object.keys(obj.filters).length === 0) {
        this.resetFilters()
        this.tags = []
      } else {
        this.filters = { ...this.filters, ...obj.filters }
        this.applyFilters()
        this.tags = obj.tags
      }
    },

    /**
     ** Removes a filter based on the provided tag and its index in the tags array. Depending on the tag's code, it removes the corresponding filter from the filters object. Additionally, it removes the tag from the tags array and applies the updated filters.
      * @param {Object} tag - The tag object to be removed.
      * @param {number} index - The index of the tag in the tags array.
      */
    removeFilter (tag, index) {
      if (tag.code[0] === 'carrier') this.filters.carrier = this.filters.carrier.filter(id => id.toString() !== tag.id.toString())
      else if (tag.code[0] === 'shipment_status') this.filters.shipment_status = this.filters.shipment_status.filter(id => id.toString() !== tag.id.toString())
      else this.filters[tag.code[0]] = null
      if (tag.code[1]) this.filters[tag.code[1]] = null
      this.tags.splice(index, 1)
      this.applyFilters()
    },

    /**
    ** Clears all filters by resetting them to their default values and clears the tags array.
    * @returns {void}
    */
    clearFilters () {
      this.resetFilters()
      this.tags = []
    },

    /**
    ** Initializes a new filters object with default values based on predefined filter elements and types. Returns an object containing default values for each filter element and type.
    * @returns {void}
    */
    initializeFilters () {
      const filterTemplate = {}
      const filterTypes = mapFilterTypes()
      const filterElements = filterConventionalShipmentList()

      filterElements.forEach(element => {
        const code = element.code
        const types = element.types

        types.forEach(type => {
          const filterType = filterTypes[type]
          const params = filterType.params.reduce((accumulator, param) => {
            accumulator[`${code}_${param}`] = null
            return accumulator
          }, {})

          Object.assign(filterTemplate, params)
        })
      })

      filterTemplate.status = []
      filterTemplate.health = []
      filterTemplate.order_dta = ''
      filterTemplate.search = ''
      filterTemplate.pol = ''
      filterTemplate.pod = ''
      filterTemplate.dta = ''
      filterTemplate.shipment_status = []

      return filterTemplate
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/conventional/PageConventionalTrackingRequestsList.vue